import { Injectable } from '@angular/core';
import { User } from '../_models/shared/user';
import { Respuesta } from '../_models/shared/_index';
import { environment } from '../../environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { SessionService } from './session.service';
import { ErrorService } from './error.service';

@Injectable({
	providedIn: 'root',
	deps: [SessionService],
})
export class EtiquetasService {
	constructor(
		public http: HttpClient,
		public sessionService: SessionService,
		private errorService: ErrorService
	) {}

	private diccTraducciones = {}; // Estructura { grupo: { ts_m: fechaModificacion, claves: [ {clave1: valor, clave2: valor, ...}] } }

	private getGrupoTraduccionesUrl =
		environment.rest + '/Idioma/GetGrupoTraducciones';
	private options = {
		headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
		withCredentials: true,
	};
	private getDescripcionesUrl: string =
		environment.rest + '/Idioma/GetNombresDescripciones';
	private idIdioma: number = 1;
	private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

	private dataKeys = new Map<string, boolean>();

	registrarTraducciones(keys: Array<string>) {
		for (let index = 0; index < keys.length; index++) {
			const key = keys[index];
			if (!this.dataKeys.has(key)) {
				this.dataKeys.set(key, false);
			}
		}
	}

	getGrupos() {
		return Array.from(this.dataKeys)
			.filter((dk) => !dk[1])
			.map((dk) => dk[0]);
	}

	/**
	 * Devuelve la etiqueta asociada a la clave proporcionada
	 * @function
	 * @param {string} grupo - Grupo de etiquetas
	 * @param {string} clave - Clave de la etiqueta
	 */
	getEtiqueta(grupo: string, clave: string): string {
		if (!grupo || !clave || !this.diccTraducciones[grupo])
			return grupo + ' > ' + clave;
		return this.diccTraducciones[grupo]['claves'][clave];
	}

	/**
	 * Devuelve la etiqueta asociada a la clave proporcionada grupo.clave
	 * @function
	 * @param {string} grupoClave - Grupo y clave de la etiqueta, unido por un punto: grupo.clave
	 */
	getEtiquetaAgrupado(grupoClave: string): string {
		let split: string[] = grupoClave.split('.');
		if (split.length != 2) return undefined;

		let grupo: string = split[0];
		let clave: string = split[1];

		return this.getEtiqueta(grupo, clave);
	}

	/**
	 * Guarda en memoria las etiquetas pertenecientes al grupo solicitado
	 * @function
	 * @param {string} grupo - Grupo de etiquetas
	 */
	getEtiquetasPorGrupo(grupo: string) {
		if (
			this.diccTraducciones[grupo] &&
			Object.getOwnPropertyNames(this.diccTraducciones[grupo]['claves'])
				.length
		) {
			return;
		}
		let idIdioma: number = this.sessionService.getCurrentUser()
			? this.sessionService.getCurrentUser().idioma.idIdioma
			: 1;
		this.getGrupoTraducciones(idIdioma, grupo).subscribe((res) => {
			if (res.Succeed) {
				if (res.Data) {
					var utc = new Date()
						.toJSON()
						.slice(0, 10)
						.replace(/-/g, '/');
					this.diccTraducciones[grupo] = {
						claves: res.Data,
						ts_m: utc,
					};
				}
			}
		});
	}

	/**
	 * Obtiene las traducciones por el idioma dado
	 * @function
	 * @param {string} grupo - Grupo de etiquetas
	 */
	getGrupoTraducciones(
		idIdioma: number,
		grupo: string
	): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(
				this.getGrupoTraduccionesUrl,
				{ idIdioma, grupo },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`POST -> getGrupoTraducciones`
					)
				)
			);
	}

	PreCargaDeTraducibles(grupo: string): Observable<boolean> {
		const obs = new Observable<boolean>((observer) => {
			if (
				this.diccTraducciones[grupo] &&
				Object.getOwnPropertyNames(
					this.diccTraducciones[grupo]['claves']
				).length
			) {
				observer.next(true);
				observer.complete();
			} else {
				let idIdioma: number = this.sessionService.getCurrentUser()
					? this.sessionService.getCurrentUser().idioma.idIdioma
					: 1;
				this.getGrupoTraducciones(idIdioma, grupo).subscribe(
					(res) => {
						if (res.Succeed) {
							if (res.Data) {
								var utc = new Date()
									.toJSON()
									.slice(0, 10)
									.replace(/-/g, '/');
								this.diccTraducciones[grupo] = {
									claves: res.Data,
									ts_m: utc,
								};
							}
							observer.next(true);
							observer.complete();
						}
					},
					(error) => {
						observer.next(false);
						observer.complete();
					}
				);
			}
		});
		return obs;
	}

	public getDescripciones(ids: Array<number>): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(this.getDescripcionesUrl, { list: ids }, options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`POST getDescripciones`
					)
				)
			);
	}

	private handleError<T>(operation = 'operation', result?: T) {
		return (error: any): Observable<Respuesta> => {
			// TODO: send the error to remote logging infrastructure
			console.error(error); // log to console instead

			// TODO: better job of transforming error for user consumption
			console.log(`${operation} failed: ${error.message}`);

			// Let the app keep running by returning an empty result.
			return of(new Respuesta());
		};
	}
}
